<template>
  <div class="Maincontent"
       :class="collapse?'position-collapse-left':'position-left'">
    <div class="Maincontent_head">
      <div class="tabList">
        <el-tabs v-model="activeTab"
                 type="card"
                 closable
                 @tab-click="selectTab"
                 @tab-remove="removeTab">
          <el-tab-pane v-for="item in TabList"
                       :key="item.name"
                       :label="item.title"
                       :name="item.name">
            <!-- b1 -->
            <!-- <deploy-list v-if="tabRefresh.item.name" /> -->
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- <el-button v-if="isRou"
                 class="tabs button"
                 @click="refresh">
        <i class="el-icon-refresh"><span class="refresh">刷新</span></i>
      </el-button> -->
      <el-dropdown class="tabs tools"
                   trigger="hover">
        <div style="font-size:1rem;width:100%;"><i class="el-icon-arrow-down"></i></div>
        <el-dropdown-menu style="width:8rem">
          <el-dropdown-item @click.native="tabsCloseCurrentHandle">关闭当前标签</el-dropdown-item>
          <el-dropdown-item @click.native="tabsCloseOtherHandle">关闭其它标签</el-dropdown-item>
          <el-dropdown-item @click.native="tabsCloseAllHandle">关闭全部标签</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="dropdown-menu"
         id="dropdown-tissue"
         v-show="dropdownTissue">
      <ul>
        <li v-for="item of TissueList"
            :key="item.id"
            :label="item.tissueName"
            :name="item.id">
          <div class="li-item"
               @click="gerenTissue(item.tissueName)">
            <span class="iconfont"
                  style="font-size:14px">{{item.tissueName}}</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="dropdown-menu"
         id="dropdown-menu"
         v-show="dropdownMenu">
      <ul>
        <li>
          <div class="li-item"
               @click="geren()">
            <span class="iconfont icongeren"
                  style="font-size:14px">&nbsp;&nbsp;个人中心</span>
          </div>
        </li>
        <li>
          <div class="li-item"
               @click="dialog('PswDialog')">
            <span class="iconfont iconmima"
                  style="font-size:14px">&nbsp;&nbsp;修改密码</span>
          </div>
        </li>
        <!-- <li>
          <div class="li-item"
               @click="dialog('ColorDialog')">
            <span class="iconfont iconjingzi"
                  style="font-size:14px">&nbsp;&nbsp;切换主题</span>
          </div>
        </li> -->
        <li class="divider"></li>
        <li>
          <!-- 注销 -->
          <div class="li-item"
               @click="loding?'':zhuxiao()">
            <span class="iconfont iconzhuxiao"
                  style="font-size:14px">&nbsp;&nbsp;退出登录</span>
          </div>
        </li>
      </ul>
    </div>
    <!-- 对话框组件 -->
    <Boyo-Dialog :dialogInfo="PswDialog"
                 @dialogEvent="pswEvent">
      <!-- 表单 -->
      <Boyo-Form :formInfo="PswInfo"
                 :refObj.sync="PswInfo.ref">
      </Boyo-Form>
    </Boyo-Dialog>
    <!-- 对话框组件 -->
    <Boyo-Dialog :dialogInfo="ColorDialog"
                 class="ThemeColor">
      <ul>
        <li v-for="(item,index) of ColorList"
            :key="index"
            class="color_item">
          <div class="ThemeItem"
               @click="changeColor(item)">
            <span style="width: 20%; float: left; height: 13px; background: #367fa9"
                  :style="item.style1"></span>
            <span style="width: 80%; float: left; height: 13px; "
                  :style="item.style2"></span>
            <span style="width: 20%; float: left; height: 30px;"
                  :style="item.style3"></span>
            <span style="width: 80%; float: left; height: 30px;"
                  :style="item.style4"></span>
            <span style="display:block; width: 100%;height:0px;overflow:hidden"></span>
          </div>
          <span style="display:block;width:100%;text-align:center">{{item.desc}}</span>
        </li>
        <li style="clear:both;height:0;padding:0"></li>
      </ul>
    </Boyo-Dialog>
    <div class="Maincontent-content">
      <!-- <keep-alive :include="includeList">
        <router-view v-if="$route.meta.keepalive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepalive"></router-view> -->
      <!-- BasicPriceAdd基础价格本添加区域价格本/BasicPriceAddCus基础价格本添加客户价格本/RegionalPrice区域价格本/RegionalPrice客户价格本/CusInformation往来单位信息详细/Delivery送货单列表/SalesWeight销售称重表|今日记录/OrderWeigh采购称重表/RegionPriceAdd区域加价表 -->
      <keep-alive exclude="SalEchartsReport,StaffAdd,BasicPriceAdd,BasicPriceAddCus,RegionalPrice,CusPriceBook,CusInformation,Delivery,WeighOne,WeighTwo,SalesOrderWeightOne,SalesDetailWeightTwo,SalesWeight,OrderWeigh,RegionPriceAdd">
        <router-view v-if="$route.meta.keepalive"></router-view>
      </keep-alive>
    </div>
    <div class="foot">© 2022 BoYo Copyright 福州博亚电子科技有限公司 徐先生 电话：15395905222</div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import md5 from 'js-md5'
import { removeTab } from '@/utils/removeTab'
import BoyoDialog from '@/components/BoyoDialog'
import BoyoForm from '@/components/BoyoForm'
export default {
  name: 'MainContent',
  provide: function () {
    return {
      reload: this.reload
    }
  },
  components: {
    BoyoDialog,
    BoyoForm
  },
  props: {},
  computed: {
    ...mapState({
      collapse: state => state.app.collapse,
      dropdownMenu: state => state.tabs.dropdownMenu,
      dropdownTissue: state => state.tabs.dropdownTissue,
      // TissueList: state => state.tabs.TissueList
    }),
    activeTab: {
      get () { return this.$store.state.tabs.activeTab },
      set (val) { this.$store.commit('updateActiveTab', val) }
    },
    TabList: {
      get () { return this.$store.state.tabs.TabList },
      set (val) { this.$store.commit('updateTabList', val) }
    },
    // TissueList: {
    //   get () { return this.$store.state.tabs.TissueList },
    //   set (val) { this.$store.commit('TissueList', val) }
    // },
    includeList: {
      get () {
        let arr = []
        for (let i in this.$store.state.tabs.TabList) {
          arr.push(this.$store.state.tabs.TabList[i].keepAlive)
        }
        return arr
      }
    }
  },
  data () {
    var validateNewPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.PswInfo.data.surePass !== '') {
          this.PswInfo.ref.validateField('surePass')
        }
        callback()
      }
    }
    var validateSurePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.PswInfo.data.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      isRou: true,
      loding: false,
      TissueList:JSON.parse(localStorage.TissueList),
      // 修改密码弹窗
      PswDialog: {
        visible: false, // 弹框是否显示
        width: '700px', // 宽度
        title: {
          reset: '重置密码'// 标题
        },
        type: 'reset', // 显示哪个标题
        // 按钮列表
        btList: [
          { label: '确定', type: 'primary', icon: '', event: 'save', loading: false },
          { label: '关闭', type: '', icon: '', event: 'close', loading: false }
        ]
      },
      // 修改密码表单
      PswInfo: {
        ref: null,
        labelWidth: '25%',
        data: {
          // id: (JSON.parse(localStorage.personal)).id,
          // name: (JSON.parse(localStorage.personal)).username,
          oldPassword: '',
          newPassword: '',
          // surePass: ''
        },
        list: [
          // { type: 'text', label: '登录名称：', value: 'name', disabled: true, style: 'width:80%' },
          { type: 'password', label: '旧密码：', value: 'oldPassword', style: 'width:80%' },
          { type: 'password', label: '新密码：', value: 'newPassword', style: 'width:80%' },
          // { type: 'password', label: '确认密码：', value: 'surePass', style: 'width:80%' }
        ],
        rules: {
          // lastPassword: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
          password: [
            { required: true, validator: validateNewPass, trigger: 'blur' },
            { min: 5, max: 16, message: '长度在 5到 16 个字符', trigger: 'blur' }
          ],
          surePass: [
            { required: true, validator: validateSurePass, trigger: 'blur' }
          ]
        }
      },
      // 切换主题弹窗
      ColorDialog: {
        visible: false, // 弹框是否显示
        width: '530px', // 宽度
        title: {
          title: '切换主题'// 标题
        },
        type: 'title' // 显示哪个标题
      },
      // 切换主题列表数据
      ColorList: [
        // { style1: 'background: #367fa9', style2: 'background: #3c8dbc', style3: 'background: #2f4050', style4: 'background: #f3f3f4', font: 'color:#fff', desc: '蓝' },
        // { style1: 'background: #008d4c', style2: 'background: #00a65a', style3: 'background: #222d32', style4: 'background: #f4f5f7', font: 'color:#fff', desc: '绿' },
        // { style1: 'background: #555299', style2: 'background: #605ca8', style3: 'background: #222d32', style4: 'background: #f3f3f4', font: 'color:#fff', desc: '紫' },
        // { style1: 'background: #dd4b39', style2: 'background: #d73925', style3: 'background: #222d32', style4: 'background: #f3f3f4', font: 'color:#fff', desc: '红' },
        // { style1: 'background: #f39c12', style2: 'background: #e08e0b', style3: 'background: #222d32', style4: 'background: #f3f3f4', font: 'color:#fff', desc: '黄' },
        { style1: 'background: #367fa9', style2: 'background: #3c8dbc', style3: 'background: #f9fafc', style4: 'background: #f3f3f4', font: 'color:black', desc: '蓝灰' },
        { style1: 'background: #008d4c', style2: 'background: #00a65a', style3: 'background: #f9fafc', style4: 'background: #f3f3f4', font: 'color:black', desc: '绿灰' },
        { style1: 'background: #555299', style2: 'background: #605ca8', style3: 'background: #f9fafc', style4: 'background: #f3f3f4', font: 'color:black', desc: '紫灰' },
        { style1: 'background: #303133', style2: 'background: #666', style3: 'background: #f9fafc', style4: 'background: #f3f3f4', font: 'color:black', desc: '灰黑' },
        { style1: 'background: #f39c12', style2: 'background: #e08e0b', style3: 'background: #f9fafc', style4: 'background: #f3f3f4', font: 'color:black', desc: '黄灰' },
        { style1: 'background: #1097a5', style2: 'background: #19b2c1', style3: 'background: #f9fafc', style4: 'background: #f3f3f4', font: 'color:black', desc: '青灰' },
        // { style1: 'background: #367fa9', style2: 'background: #3c8dbc', style3: 'background: #0F2950', style4: 'background: #f3f3f4', font: 'color:#fff', desc: '蓝浅' },
        // { style1: 'background: #008d4c', style2: 'background: #00a65a', style3: 'background: #0F2950', style4: 'background: #f3f3f4', font: 'color:#fff', desc: '绿浅' }
      ]
    }
  },
  methods: {
    //刷新
    reload: function () {
      this.isRou = false;
      this.$nextTick(function () {
        this.isRou = true;
      })
    },
    // 修改密码对话框按钮事件
    pswEvent (event) {
      const PswDialog = this.PswDialog
      const PswInfo = this.PswInfo
      switch (event) {
        case 'save':
          PswInfo.ref.validate((val) => {
            if (val) {
              const params = JSON.parse(JSON.stringify(this.PswInfo.data))
              let oldPass = params.oldPassword
              let newPass = params.newPassword
              params.oldPassword = md5.hex(params.oldPassword)
              params.newPassword = md5.hex(params.newPassword)
              PswDialog.btList[0].loading = true
              this.$api.user.password(params).then(res => {
                PswDialog.btList[0].loading = false
                if (res.code === 0) {
                  this.$message({ message: res.msg, type: 'success' })
                  PswDialog.visible = false
                } else {
                  params.oldPassword = oldPass
                  params.newPassword = newPass
                  this.$message({ message: res.msg, type: 'error' })
                }
              }, err => {
                console.log(err)
                PswDialog.btList[0].loading = false
              })
            }
          })
          break
        case 'close':
          PswDialog.visible = false
          this.PswInfo.ref.resetFields()
          break
      }
    },
    // 修改主题颜色
    changeColor (item) {
      this.$store.commit('logoColor', item.style1)
      this.$store.commit('headColor', item.style2)
      this.$store.commit('navColor', item.style3)
      this.$store.commit('fontColor', item.font)
    },
    // 个人中心
    geren () {
      this.$router.push('/index/personal')
      this.$store.commit('dropdownMenu', false)
    },
    gerenTissue (name) {// 组织切换
      this.$store.commit('dropdownTissue', false)
      if (localStorage.loginTissueName == name) {
        // console.log(name)
      }else{
        this.$confirm('确认切换选中的组织吗？', '提示', {
          type: 'warning'
        }).then(() => {
          localStorage.loginTissueName = name
          for (let index of this.TissueList) {
            if (index.tissueName == name) {
              localStorage.loginTissueId = index.id
              localStorage.tPrefixion = index.tPrefixion
              location.reload()
            }
          }
        })
      }
    },
    // 打开对话框
    dialog (dialog) {
      this[dialog].visible = true
    },
    // 注销
    zhuxiao () {
      this.$confirm('即将退出系统，是否继续？', '提示', {
        type: 'warning'
      }).then(() => {
        this.loding = true
        this.$store.commit('loding', true)
        this.$api.login.out().then(res => {
          this.loding = false
          this.$store.commit('loding', false)
          if (res.code === 0) {
            localStorage.clear()
            // console.log(localStorage);
            this.$message({ message: res.msg, type: 'success' })
            localStorage.removeItem("token");
            // localStorage.removeItem('client')
            localStorage.removeItem('roleId')
            localStorage.removeItem('userButtonList')//用户菜单按钮权限
            this.$store.commit('RouterLoad', false)
            this.$router.push('/login')
            this.$store.commit('updateTabList', [])
            this.$store.commit('updateActiveTab', '')
          } else {
            this.$message({ message: res.msg, type: 'error' })
          }
        }, err => {
          console.log(err)
          localStorage.removeItem('token')
          localStorage.removeItem('roleId')
          this.$router.push('/login')
          this.loding = false
          this.$store.commit('loding', false)
        })
      })
    },
    // 点击标签路由跳转
    selectTab (tab) {
      this.$router.push({ name: tab.name })
      localStorage.menuNameActive = tab.name
    },
    // 移除标签
    removeTab (tabName) {
      let that = this
      removeTab(tabName, that)
    },
    // tabs, 关闭当前
    tabsCloseCurrentHandle () {
      this.removeTab(this.activeTab)
    },
    // tabs, 关闭其它
    tabsCloseOtherHandle () {
      this.TabList = this.TabList.filter(item => item.name === this.activeTab)
    },
    // tabs, 关闭全部
    tabsCloseAllHandle () {
      this.TabList = []
      this.$router.push('/index')
    },
    // 刷新
    refresh () {
      let arr = JSON.parse(JSON.stringify(this.TabList))
      for (let i in arr) {
        if (arr[i].name === this.$route.name) {
          arr[i].keepAlive = '0' + arr[i].keepAlive
        }
      }
      // 将要刷新的路由keepAlive的值变成空
      this.TabList = arr
      this.$router.replace({
        path: '/index/refresh',
        query: {
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.Maincontent>>>.el-form-item__error
  top 30%
  right 25%
  left 50%
  text-align right
.Maincontent>>>.el-form--inline .el-form-item__error
  top 30%
  right 25px
  text-align right
.ThemeColor >>>.el-dialog__body
  padding 8px
  background #f3f3f4
.position-left
  left 10rem
.position-collapse-left
  left 3rem
.tabList
  position absolute
  top 0
  left 0
  height 2rem
  width 3.5%
  width 93%
  border-bottom 0.05rem solid rgba(200, 206, 206, 0.5)
.tabs
  position absolute
  top 0
  height 2rem
  width 3.5%
  font-size 0.7rem
  line-height 2rem
  cursor pointer
  border-bottom 0.05rem solid rgba(200, 206, 206, 0.5)
  border-left 0.05rem solid rgba(200, 206, 206, 0.5)
  background rgba(255, 255, 255, 1)
.tools
  right 0
.button
  right 3.5%
  border-top 0
  border-right 0
  box-sizing content-box
  padding 0
.tabs-tools:hover
  background rgba(200, 206, 206, 1)
.color_item
  width 33.333%
  float left
  padding 5px
  box-sizing border-box
  .ThemeItem
    box-shadow 0 0 5px rgba(86, 96, 117, 0.3)
    border 1px solid #fff
    box-sizing border-box
  .ThemeItem:hover
    border 1px solid red
.foot
  position absolute
  bottom 0
  left 0
  right 0
  box-sizing border-box
  padding 10px 20px
  background #fff
  font-size 13px
  text-align center
  border-top 1px solid #e7eaec
</style>



// WEBPACK FOOTER //
// src/views/MainContent/MainContent.vue